import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducers } from './reducer';
import { WatchlistSnapshotsEffects } from './effects/watchlist-snapshots.effects';
import { WatchlistSnapshotsService } from './service/watchlist-snapshots.service';


@NgModule({
  imports: [
    StoreModule.forFeature('watchlistSnapshots', reducers),
    EffectsModule.forFeature([WatchlistSnapshotsEffects])
  ],
  providers: [
    WatchlistSnapshotsService
  ]
})
export class WatchlistSnapshotsStoreModule {}
